export const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: 'white'
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 12
  },
  card: {
    marginTop: 30,
    maxWidth: 600,
    paddingBottom: 15
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  avatarWrapper: {
    display: 'flex',
    margin: '1em',
    justifyContent: 'center'
  },
  avatar: {
    width: '6em',
    height: '6em'
  },
  input: {
    display: 'none'
  }
}



// WEBPACK FOOTER //
// ./src/pages/Profile/styles.js